var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_3248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 27.9999H22.1667V22.1164C22.1657 21.2018 21.802 20.3248 21.1552 19.678C20.5084 19.0313 19.6315 18.6675 18.7168 18.6666H9.28317C8.3685 18.6675 7.49156 19.0313 6.84479 19.678C6.19802 20.3248 5.83426 21.2018 5.83333 22.1164V27.9999H3.5V22.1164C3.50185 20.5832 4.11174 19.1133 5.1959 18.0291C6.28005 16.945 7.74994 16.3351 9.28317 16.3333H18.7168C20.2501 16.3351 21.72 16.945 22.8041 18.0291C23.8883 19.1133 24.4981 20.5832 24.5 22.1164V27.9999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14C12.6155 14 11.2622 13.5895 10.111 12.8203C8.95987 12.0511 8.06266 10.9579 7.53285 9.67879C7.00303 8.3997 6.86441 6.99224 7.13451 5.63437C7.4046 4.2765 8.07129 3.02922 9.05026 2.05026C10.0292 1.07129 11.2765 0.404603 12.6344 0.134506C13.9922 -0.13559 15.3997 0.003033 16.6788 0.532846C17.9579 1.06266 19.0511 1.95987 19.8203 3.11101C20.5895 4.26216 21 5.61553 21 7C20.9982 8.85595 20.2601 10.6354 18.9477 11.9477C17.6354 13.2601 15.856 13.9982 14 14ZM14 2.33334C13.077 2.33334 12.1748 2.60703 11.4073 3.11981C10.6399 3.63259 10.0418 4.36143 9.68857 5.21415C9.33536 6.06687 9.24294 7.00518 9.42301 7.91043C9.60307 8.81567 10.0475 9.64719 10.7002 10.2998C11.3528 10.9525 12.1843 11.3969 13.0896 11.577C13.9948 11.7571 14.9331 11.6647 15.7859 11.3114C16.6386 10.9582 17.3674 10.3601 17.8802 9.59266C18.393 8.82524 18.6667 7.92298 18.6667 7C18.6667 5.76233 18.175 4.57534 17.2998 3.70017C16.4247 2.825 15.2377 2.33334 14 2.33334Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_3248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.4ea1e9977bf57ed7baa2bc90952cbf54.svg";
export { ForwardRef as ReactComponent };